<h4 class="nx-margin-top-10 nx-margin-bottom-30">Vehicle Details</h4>
<table nxTable class="summary_table">
    <tr nxTableRow *ngFor="let item of getFilteredVehicleDetailsLabels()">
        <td nxTableCell>
            <span nxCopytext="normal">{{ item.label }}</span>
        </td>
        <td nxTableCell class="column_cp_content">
            <span nxCopytext="normal">
                {{ getValue(item.key, 'vehicleDetails') }}
            </span>
        </td>
    </tr>
</table>

<hr class="nx-margin-y-2m" />
<h4 class="nx-margin-top-30 nx-margin-bottom-30">Coverage Details</h4>
<table nxTable class="summary_table">
    <tr nxTableRow *ngFor="let item of coverageDetailsLabels">
        <td nxTableCell>
            <span nxCopytext="normal">{{ item.label }}</span>
        </td>
        <td nxTableCell class="column_cp_content">
            <span nxCopytext="normal">
                <ng-container *ngIf="(viewQuotation || viewPolicyDetails) && item.key === 'sumInsured'">
                    {{ generateSIWording(getValue(item.key, 'coverageDetails')) }}
                    @if (sumInsuredText) {
                        <span nxCopytext="small">
                            <i> {{ sumInsuredText }}</i>
                        </span>
                    }
                </ng-container>
                <ng-container *ngIf="!((viewQuotation || viewPolicyDetails) && item.key === 'sumInsured')">
                    {{ getValue(item.key, 'coverageDetails') }}
                </ng-container>
            </span>
        </td>
    </tr>
</table>

@if(extraCoverPackageSummary && showExtraCoverage){
<hr class="nx-margin-y-2m" />
<h4 class="nx-margin-bottom-30">Extra Coverage</h4>
@if((extraCoverPackageSummary.rahmahPackageList?.length > 0 && !extraCoverPackageSummary.costInd) || extraCoverPackageSummary.topExtraCoverList?.length > 0){
<span nxCopytext="normal" class="nx-font-weight-semibold">These coverage(s) / service(s) are provided at no extra
    cost.</span>
}

@if((!viewQuotation) && (!extraCoverPackageSummary.costInd)){
<div class="coverage">
    <table class="extra_package_summary">
        <tbody>
            <tr nxTableRow>
                <td>
                    <ul nxList="small" class="extra_coverage_list_summary">
                        <li>
                            <span nxCopytext="normal" class="nx-font-weight-semibold">{{
                                extraCoverPackageSummary.subCovPackageList?.packageDescription ||
                                extraCoverPackageSummary.subCovPackageDesc | uppercase
                                }}</span>
                        </li>
                    </ul>
                </td>
                <td></td>
                <td class="nx-hidden-xs nx-hidden-s"></td>
            </tr>
            <tr nxTableRow *ngFor="let item of extraCoverPackageSummary.rahmahPackageList; let i = index">
                <td>
                    <div class="sub_cover_summary">
                        <ul nxList>
                            <li nxListIcon="minus" size="s">
                                <p nxCopytext="medium">
                                    {{ item.description || item.subCoverCodeDescription }}
                                </p>
                            </li>
                        </ul>
                    </div>
                </td>
                <td class="std-ta-right" [innerHTML]="removeNewLinesFromOpus(item.subcoverNarrDesc, item.subCoverCode)">
                </td>
                <td class="nx-hidden-xs nx-hidden-s"></td>
            </tr>
        </tbody>
    </table>
</div>

}
@if((viewQuotation) && (!extraCoverPackageSummary.costInd)){
<div class="coverage">
    <table class="extra_package_summary">
        <tbody>
            <tr nxTableRow>
                <td>
                    <ul nxList="small" class="extra_coverage_list_summary">
                        <li>
                            <span nxCopytext="normal" class="nx-font-weight-semibold">{{
                                extraCoverPackageSummary.subCovPackageList?.packageDescription ||
                                extraCoverPackageSummary.subCovPackageDesc | uppercase
                                }}</span>
                        </li>
                    </ul>
                </td>
                <td></td>
                <td class="nx-hidden-xs nx-hidden-s"></td>
            </tr>
            <tr nxTableRow *ngFor="let item of extraCoverPackageSummary.rahmahPackageList; let i = index">
                <td>
                    <div class="sub_cover_summary">
                        <ul nxList>
                            <li nxListIcon="minus" size="s">
                                <p nxCopytext="medium">
                                    {{ item.description || item.subCoverCodeDescription }}
                                </p>
                            </li>
                        </ul>
                    </div>
                </td>
                <td class="std-ta-right" [innerHTML]="removeNewLinesFromOpus(item.subcoverNarrDesc, item.subCoverCode)">
                </td>
                <td class="nx-hidden-xs nx-hidden-s"></td>
            </tr>
        </tbody>
    </table>
</div>

}
@if(extraCoverPackageSummary.topExtraCoverList?.length > 0){
<div class="coverage nx-margin-bottom-30">
    <table class="extra_package_summary">
        <tbody>
            <tr nxTableRow class="nx-margin-bottom-2m"
                *ngFor="let item of extraCoverPackageSummary.topExtraCoverList; let i = index">
                <td>
                    <ul nxList="small" class="extra_coverage_list_summary">
                        <li>
                            <span nxCopytext="normal" class="nx-font-weight-semibold">{{ item.description ||
                                item.subCoverCodeDescription}}</span>
                            <ng-container *ngIf="item.subCoverBenefitList?.length && item.subCoverCode === 'PAB3' || item.subCoverCode === 'PAB-DG'">
                                <div class="extra-coverage-padding-top-quo">
                                    <ul nxList>
                                        <li style="margin-bottom: 0px !important;" nxListIcon="" size="s"
                                            *ngFor="let subItem of item.subCoverBenefitList">
                                            <div nxCopytext="medium">
                                                <div nxRow col="12">
                                                    <div>- </div>
                                                    <div class="extra-coverage-description-quo">{{
                                                        subItem.subCoverBenefitDescp }}</div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                        </li>
                    </ul>
                </td>
                <td class="sub_si">
                    <span [innerHTML]="removeNewLinesFromOpus(item.subcoverNarrDesc, item.subCoverCode)"></span>
                </td>
                <td class="extra-coverage-hidden-col-medium"></td>
            </tr>
        </tbody>
    </table>
</div>
}
@if(extraCoverPackageSummary.rahmahPackageList?.length > 0 &&
(extraCoverPackageSummary.subCovPackageList?.packageDescription || extraCoverPackageSummary.subCovPackageDesc) &&
extraCoverPackageSummary.costInd){
<div nxRow class="nx-margin-top-m">
    <div nxCol="10" class="nx-font-weight-semibold cell-padding-bottom">Extra Coverage Package</div>
</div>
<div class="coverage nx-margin-bottom-30">
    <table class="extra_package_summary">
        <tbody>
            <tr nxTableRow>
                <td>
                    <ul nxList="small" class="extra_coverage_list_summary">
                        <li>
                            <span nxCopytext="normal" class="nx-font-weight-semibold">{{
                                extraCoverPackageSummary.subCovPackageList?.packageDescription ||
                                extraCoverPackageSummary.subCovPackageDesc | uppercase}}</span>
                        </li>
                    </ul>
                </td>
                <td></td>
                <td class="nx-hidden-xs nx-hidden-s"></td>
            </tr>
            <tr nxTableRow *ngFor="let item of extraCoverPackageSummary.rahmahPackageList; let i = index">
                <td>
                    <div class="sub_cover_summary">
                        <ul nxList>
                            <li nxListIcon="minus" size="s">
                                <p nxCopytext="medium">
                                    {{ item.description || item.subCoverCodeDescription }}
                                </p>
                            </li>
                        </ul>
                    </div>
                </td>

                <td class="sub_si" [innerHTML]="removeNewLinesFromOpus(item.subcoverNarrDesc, item.subCoverCode)">
                </td>
                <td class="nx-hidden-xs nx-hidden-s"></td>
            </tr>
        </tbody>
    </table>
</div>
}

@if((!viewQuotation)&& (!viewPolicyDetails)){
<ng-container *ngIf="extraCoverPackageSummary.selectedExtraCoverList.length > 0">
    <div class="nx-margin-top-2m">
        <app-external-scrollbar targetSyncScroll="1" [targetBaseWidth]="tableHolder1"></app-external-scrollbar>
        <div class="table-holder table_content_scroll only-this-horizon-scrollbar" #tableHolder1 syncScroll="1">

            <table nxTable zebra aria-label="Table for selected extra coverage">
                <thead>
                    <tr nxTableRow class="table_row_flex">
                        <th nxHeaderCell class="table_extra_coverage">
                            <span nxCopytext="medium" class="nx-font-weight-semibold">Extra Cover</span>
                        </th>
                        <th nxHeaderCell class="table_extra_coverage"></th>
                        <th nxHeaderCell class="table_extra_coverage">
                            <span nxCopytext="medium" class="nx-font-weight-semibold no-wrap">Premium (RM)</span>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr nxTableRow class="table_row_flex"
                        *ngFor="let item of extraCoverPackageSummary.selectedExtraCoverList">
                        <td nxTableCell class="table_extra_coverage">
                            <!-- p2p -->
                            @if(item.subCoverCode === 'A207'){
                            <span nxCopytext="medium">{{ item.subCoverDescp || item.description }}</span>
                            }

                            @if(item.subCoverCode !== 'A207'){
                            <span nxCopytext="medium">{{ item.description }}</span>
                            }
                            <!-- summary -->
                            <ng-container *ngIf="item.cngeSubCoverBenefitDtoList?.length && item.subCoverCode === 'PAB3' || item.subCoverCode === 'PAB-DG'">
                                <div class="sub_cover extra-coverage-padding-top" style="padding-left: 0; margin-left: 0;">
                                    <ul nxList>
                                        <li style="margin-bottom: 0px !important; padding-left: 0; margin-left: 0;" nxListIcon="" size="s"
                                            *ngFor="let subItem of item.cngeSubCoverBenefitDtoList">
                                            <div nxCopytext="medium">
                                                <div nxRow col="12" style="padding-left: 0; margin-left: 0;">                                                
                                                    <div>-&nbsp;&nbsp;</div>
                                                    <div class="extra-coverage-description" style="padding-left: 0; margin-left: 0;">{{
                                                        subItem.subCoverBenefitDescp }}</div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>

                            <!-- generate quotation > update Quotation > summary-->
                            <ng-container *ngIf="item.subCoverBenefitList?.length && item.subCoverCode === 'PAB3' || item.subCoverCode === 'PAB-DG'">
                                <div class="sub_cover extra-coverage-padding-top">
                                    <ul nxList>
                                        <li style="margin-bottom: 0px !important;" nxListIcon="" size="s"
                                            *ngFor="let subItem of item.subCoverBenefitList">
                                            <div nxCopytext="medium">
                                                <div nxRow col="12">
                                                    <div>- </div>
                                                    <div class="extra-coverage-description">{{
                                                        subItem.subCoverBenefitDescp }}</div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                        </td>
                        <td nxTableCell class="table_extra_coverage">
                            <span [innerHTML]="removeNewLinesFromOpus(item.subcoverNarrDesc, item.subCoverCode)"></span>
                        </td>
                        <td nxTableCell class="table_extra_coverage">
                            <ng-container *ngIf="item.subCoverCode !== 'A221' && item.subCoverCode !== '57'  || (item.subCoverCode === 'A221' && item.subCoverPrem != 0) || showPremium(item.subCoverCode, item.subCoverPrem)">
                                <span nxCopytext="medium">{{ item.subCoverPrem| formatDecimal }}</span>
                            </ng-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-container>
}
@if((viewQuotation) || (viewPolicyDetails)){
<ng-container *ngIf="extraCoverPackageSummary.selectedExtraCoverList.length > 0">
    <div class="nx-margin-top-2m">
        <app-external-scrollbar targetSyncScroll="1" [targetBaseWidth]="tableHolder1"></app-external-scrollbar>
        <div class="table-holder table_content_scroll only-this-horizon-scrollbar" #tableHolder1 syncScroll="1">

            <table nxTable zebra>
                <thead>
                    <tr nxTableRow class="table_row_flex">
                        <th nxHeaderCell class="table_extra_coverage_quo">
                            <span nxCopytext="medium" class="nx-font-weight-semibold">Extra Cover</span>
                        </th>
                        <th nxHeaderCell class="table_extra_coverage_quo"></th>
                        <th nxHeaderCell class="table_extra_coverage_quo">
                            <span nxCopytext="medium" class="nx-font-weight-semibold">Premium (RM)</span>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr nxTableRow class="table_row_flex"
                        *ngFor="let item of extraCoverPackageSummary.selectedExtraCoverList">
                        <td nxTableCell class="table_extra_coverage">
                            <!-- p2p -->
                            @if(item.subCoverCode === 'A207'){
                            <span nxCopytext="medium">{{ item.subCoverDescp || item.description }}</span>
                            }

                            @if(item.subCoverCode !== 'A207'){
                            <span nxCopytext="medium">{{ item.description }}</span>
                            }

                            <!-- view Quotation -->
                            <ng-container *ngIf="item.subCoverBenefitList?.length && item.subCoverCode === 'PAB3' || item.subCoverCode === 'PAB-DG'">
                                <div class="sub_cover extra-coverage-padding-top-quo">
                                    <ul nxList>
                                        <li style="margin-bottom: 0px !important;" nxListIcon="" size="s"
                                            *ngFor="let subItem of item.subCoverBenefitList">
                                            <div nxCopytext="medium">
                                                <div nxRow col="12">
                                                    <div>- </div>
                                                    <div class="extra-coverage-description-quo">{{
                                                        subItem.subCoverBenefitDescp }}</div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </ng-container>
                        </td>
                        <td nxTableCell class="table_extra_coverage">
                            <span [innerHTML]="removeNewLinesFromOpus(item.subcoverNarrDesc, item.subCoverCode)"></span>
                        </td>
        
                        <td nxTableCell class="table_extra_coverage">
                            <ng-container *ngIf="item.subCoverCode !== 'A221' && item.subCoverCode !== '57'  || (item.subCoverCode === 'A221' && item.subCoverPrem != 0) || showPremium(item.subCoverCode, item.subCoverPrem)">
                                <span nxCopytext="medium">{{ item.subCoverPrem | formatDecimal }}</span>
                            </ng-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-container>
}
}

@if(showNamedDriver) {
<hr class="nx-margin-y-2m" />
<h4 class="nx-marginm-2m">Named Drivers</h4>
<div class="nx-margin-top-2m-botto">
    <app-external-scrollbar targetSyncScroll="2" [targetBaseWidth]="tableHolder2"></app-external-scrollbar>
    <div class="table-holder table_content_scroll only-this-horizon-scrollbar" #tableHolder2 syncScroll="2">
        <table nxTable zebra class="nameddriver_table">
            <thead>
                <tr nxTableRow>
                    <th nxHeaderCell *ngFor="let header of driverHeaderLabels"
                        [ngClass]="header.key === 'driverAge' ? 'age_column' : ''">
                        <span nxCopytext="medium" class="nx-font-weight-semibold">{{ header.label }}</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr nxTableRow *ngFor="let driver of namedDriverList">
                    <td nxTableCell *ngFor="let header of driverHeaderLabels">
                        @if(header.key === 'driverId') {
                            <span nxCopytext="medium">{{ formatDriverAgeAndId(driver[header.key]) }}</span>
                        }
                        @else if(header.key === 'driverAge') {
                            @if (isNRICValid(driver['driverId'])) {
                                <span nxCopytext="medium">{{ formatDriverAgeAndId(driver['driverAge']) }}</span>
                            }
                            @else {
                                <span nxCopytext="medium">{{ formatDriverAgeAndId(driver['driverAge']) }}</span>
                            }
                        }
                        @else {
                            <span nxCopytext="medium" class="text_no_wrap">{{ driver[header.key] || 'N/A' }}</span>
                        }
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
}

@if(showEhailing) {
<h4 class="nx-margin-bottom-2m">e-Hailing Drivers Name</h4>
<div class="nx-margin-top-2m">
    <app-external-scrollbar targetSyncScroll="3" [targetBaseWidth]="tableHolder3"></app-external-scrollbar>
    <div class="table-holder table_content_scroll only-this-horizon-scrollbar" #tableHolder3 syncScroll="3">
        <table nxTable zebra class="ehailing_table">
            <thead>
                <tr nxTableRow>
                    <th nxHeaderCell *ngFor="let header of ehailingDriverHeaderLabels">
                        <span nxCopytext="medium" class="nx-font-weight-semibold">{{ header.label }}</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr nxTableRow *ngFor="let driver of ehailingDriverList">
                    <td nxTableCell *ngFor="let header of ehailingDriverHeaderLabels">
                        <span nxCopytext="medium">{{ driver[header.key] }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
}

@if(thailandTripDate){
<hr class="nx-margin-y-2m" />
<h4 class="nx-margin-top-10 nx-margin-bottom-30">Thailand Trip</h4>
<table nxTable class="summary_table">
    <tr nxTableRow>
        <td nxTableCell>
            <span nxCopytext="normal">Start Date</span>
        </td>
        <td nxTableCell class="column_cp_content">
            <span nxCopytext="normal">
                {{ (thailandTripDate.currentThaiStartDate || thailandTripDate.effectiveDate) | date:'dd/MM/yyyy' }}
            </span>
        </td>
    </tr>
    <tr nxTableRow>
        <td nxTableCell>
            <span nxCopytext="normal">End Date</span>
        </td>
        <td nxTableCell class="column_cp_content">
            <span nxCopytext="normal">
                {{ (thailandTripDate.currentThaiEndDate || thailandTripDate.expiryDate) | date:'dd/MM/yyyy'}}
            </span>
        </td>
    </tr>
</table>
}